function gtagEvent(name, category, label, value) {
    const event = {
        event_category: category,
        event_label: label,
        value: value,
        user_properties: getGtagConsent(),
    };

    gtag('event', name, event);
}

//
// permet de suivre si un utilisateur clique
//
export function clickGtagEvent(selector, name, label, options) {
    let category = 'CAT';
    let value = 1;

    if (options) {
        category = options.category ?? category;
        value = options.value ?? value;
    }

    document.addEventListener('click', function (e) {
        var target = e.target;

        if (target.closest && target.closest(selector)) {
            if (typeof gtag === 'function') {
                if (target && target.innerText) {
                    label = label + ' : "' + target.innerText + '"';
                }

                gtagEvent(name, category, label, value);
            }
        }
    });
}

//
// permet de suivre si un utilisateur commence à taper dans un champ
//
// input :
// - 1 : envoi d'un seul événement pour l'ensemble des champs
// - false : envoie d'un événement pour chaque champ
// - ['#input-1', '#input-2'] : envoi d'un événement pour chaque identifiant d'input spécifié
//
export function inputStartGtagEvent(selector, mode, name, label, options) {
    let category = 'Formulaire';
    let value = 1;

    if (options) {
        category = options.category ?? category;
        value = options.value ?? value;
    }

    const form = document.querySelector(selector);

    if (form) {
        let selectors = 'input, textarea, select';

        if (Array.isArray(mode)) {
            selectors = mode.join(',');
        }

        const inputs = form.querySelectorAll(selectors);

        let started = false;

        inputs.forEach((input) => {
            input.addEventListener('input', (target) => {
                if (mode != 1 || started == false) {
                    let labelText = false;

                    const labelFor = form.querySelector('label[for="' + input.id + '"]');

                    if (labelFor) {
                        labelText = labelFor.innerText.trim();
                    }

                    label = label + ' : ' + (labelText || input.name || input.id || 'champ_inconnu');

                    gtagEvent(name, category, label, value);
                }

                started = true;

            }, { once: true });
        });
    }
}

//
// permet de suivre si un utilisateur envoie un formulaire
//
export function submitGtagEvent(selector, name, label, options) {
    let category = 'Formulaire';
    let value = 1;

    if (options) {
        category = options.category ?? category;
        value = options.value ?? value;
    }

    document.addEventListener('submit', function (e) {
        var form = e.target;

        if (form && form.id === selector) {
            if (typeof gtag === 'function') {
                if (form) {
                    const submitButton = form.querySelector('[type="submit"]');
                    const buttonText = submitButton ? submitButton.innerText.trim() : false;

                    if (buttonText) {
                        label = label + ' : "' + buttonText + '"';
                    }
                }

                gtagEvent(name, category, label, value);
            }
        }
    }, true);
}

//
// permet de suivre l'affichage d'un élément sur une page
//
export function elementGtagEvent(selector, name, label, options) {
    let category = 'Element';
    let value = 1;

    if (options) {
        category = options.category ?? category;
        value = options.value ?? value;
    }

    if (document.querySelector(selector)) {
        if (typeof gtag === 'function') {
            gtagEvent(name, category, label, value);
        }
    }
}

//
// configuration du consent mode v2 de google
//
function getGtagConsent() {
    let ad_storage = typeof cmplz_has_consent !== "undefined" && cmplz_has_consent('marketing') ? 'granted' : 'denied';
    let analytics_storage = typeof cmplz_has_consent !== "undefined" && cmplz_has_consent('statistics') ? 'granted' : 'denied';
    let ad_user_data = typeof cmplz_has_consent !== "undefined" && cmplz_has_consent('marketing') ? 'granted' : 'denied';
    let ad_personalization = typeof cmplz_has_consent !== "undefined" && cmplz_has_consent('marketing') ? 'granted' : 'denied';

    const consent = {
        ad_storage: ad_storage,
        analytics_storage: analytics_storage,
        ad_user_data: ad_user_data, // consentement pour l'envoi de données utilisateur liées à la publicité à google
        ad_personalization: ad_personalization, // consentement pour la publicité personnalisée
    };

    return consent;
}

function setGtagConsent(mode) {
    gtag('consent', mode, getGtagConsent());
}

//
// initialisation du gtag
//
export function addGtagOnConsent(gtagEvents, collect = true, debug = false) {
    const GA_MEASUREMENT_ID = global.ga_measurment_id;

    var s = document.createElement('script');

    s.src = 'https://www.googletagmanager.com/gtag/js?id=' + GA_MEASUREMENT_ID;
    s.async = true;

    document.head.appendChild(s);

    if (!collect) {
        window['ga-disable-' + GA_MEASUREMENT_ID] = true;
    }

    window.dataLayer = window.dataLayer || [];

    function gtag() {
        dataLayer.push(arguments);
    }

    window.gtag = gtag;

    setGtagConsent('default');

    gtag('js', new Date());
    gtag('set', 'user_properties', getGtagConsent());

    if (debug) {
        gtag(
            'config', GA_MEASUREMENT_ID, {
            'debug_mode': true,
            'traffic_type': 'debug',
        });
    } else {
        gtag('config', GA_MEASUREMENT_ID);
    }

    gtagEvents();

    document.addEventListener('cmplz_status_change', function (consentData) {
        setGtagConsent('update');
    });
}